import { Constants } from '../constants/create-survey.constants';
import { LayoutConstants } from '../../create-surveys/layout/layout-constants';
import { HighCpiConfrmationResponse } from '../interfaces/survey.interface';
import { SURVEY_STATUS } from '../constants/survey-status';

export class SurveyHighCpiConfirmationInspector {
  constructor(private readonly _data: Details) {}

  public check(): boolean {
    if (this._data.data_type === 'high-cpi-data') {
      return (
        this._data.next_status === SURVEY_STATUS.LIVE &&
        !!this._data.highCpiDetails.isPriceGreaterThanCpiThreshold
      );
    }

    return this._data.cpi > LayoutConstants.MAX_CPI_THRESHOLD;
  }

  public text(): string {
    if (this._data.data_type === 'high-cpi-data') {
      return Constants.CONFIRM_MODAL_TEXT.HIGH_CPI.replace(
        '<CPI>',
        `${this._data.highCpiDetails.pricingDetails.value}`
      ).replace(
        '<CURRENCY_SYMBOL>',
        `${this._data.highCpiDetails.pricingDetails.currency || '$'}`
      );
    }

    return Constants.CONFIRM_MODAL_TEXT.HIGH_CPI.replace(
      '<CPI>',
      `${this._data.surveyData.current_cpi}`
    ).replace(
      '<CURRENCY_SYMBOL>',
      `${this._data.surveyData.currency_symbol || '$'}`
    );
  }
}

type SurveyData = {
  data_type: 'survey-data';
  cpi: number;
  surveyData: {
    current_cpi: number;
    currency_symbol: string;
  };
};

type HighCpiData = {
  data_type: 'high-cpi-data';
  next_status: number;
  highCpiDetails: HighCpiConfrmationResponse;
};

type Details = SurveyData | HighCpiData;
